import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {EventBusService} from "../services/eventbus/event-bus.service";
import {MetaData} from "ng-event-bus/lib/meta-data";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {SubscriptionContainerService} from "../services/subscription-container.service";
import {AbstractControl, FormGroup} from "@angular/forms";
import {ValidationUtil} from "../../utils/validation.util";
import {CommonBase} from "../common/base.common";
import {StringUtil} from "../../utils/string.util";
import {Meta, Title} from "@angular/platform-browser";
import {environment} from "../../../environments/environment";
import {fadeInOut} from "../animations/component.animation";
import {translations} from "../../modules/dash/layout/left-nav/menu.model";

@Component({
  template: ``,
  animations: [
    fadeInOut("dataLoaded", "loading", "loaded")
  ]
})
export abstract class BaseComponent extends CommonBase implements OnInit, OnDestroy {
  protected readonly translations = translations;

  protected constructor(
    protected eventBus: EventBusService,
    protected router: Router,
    protected subContainer: SubscriptionContainerService
  ) {
    super();
  }

  @Input() loading = true

  protected abstract componentName(): string

  subscribe(key: string, navUrl: string | null, then: (value: boolean, meta: MetaData) => void): Subscription | null {

    if (this.subContainer.hasKey(key)) {
      // console.log("KEY ALREADY EXISTS, UNSUBSCRIBING: " + key)
      this.subContainer.disposeSubscription(key)
      // console.log(Array.from(this.subContainer.getKeys().keys()))
      // console.log("------------------------")
    }

    let sub = this.eventBus.on(key)
      .subscribe((meta: MetaData) => {
        if (navUrl != null) {
          this.router.navigate([navUrl])
            .then((value: boolean) => {
              then(value, meta);
            })
        } else then(false, meta);
      });

    this.subContainer.add(key, sub);
    // console.log("SUBSCRIBED")
    // console.log(Array.from(this.subContainer.getKeys().keys()))
    // console.log("------------------------")
    return sub;
  }

  reloadRoute() {
    this.navigate(this.router.url, value => {
    })
  }

  reloadRouteByUrl() {
    this.navigateByUrl(this.router.url, value => {
    })
  }

  navigate(navUrl: string, then: (value: boolean) => void) {
    if (navUrl == this.router.url) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
    }

    if (navUrl != null)
      this.router.navigate([navUrl]).then(r => then(r))
  }

  navigateByUrl(navUrl: string, then: (value: boolean) => void = ()=>{}) {
    if (navUrl == this.router.url) {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
    }

    if (navUrl != null)
      this.router.navigateByUrl(navUrl).then(r => then(r))
  }

  goHomeAndDoABarrelRoll(stupidAction: (r: string) => void) {
    this.router.navigateByUrl("").then(r => stupidAction)
  }

  abstract ngOnInit(): void

  ngOnDestroy() {
    // console.log("BaseComponent Destroy called.")
    this.subContainer.disposeForComponent(this.constructor.name);
  }

  isInvalidInput(formControl: AbstractControl): boolean {
    return ValidationUtil.isInvalidInput(formControl)
  }

  protected getFormError(formControl: AbstractControl, validationName: string): any {
    return ValidationUtil.getFormError(formControl, validationName)
  }

  protected componentKey(key: string): string {
    return this.componentName() + ':' + key
  }

  protected globalKey(key: string): string {
    return 'global:' + key
  }

  firstWord(str: string | null | undefined): string {
    return StringUtil.firstWord(str)
  }

  errMsg(formGroup: FormGroup, controlName: string, validation: string, msg: string): string | null {
    // @ts-ignore
    let title = formGroup.controls[controlName]
    if (title.touched && title.errors ? [validation].length : 0 > 0) {
      return msg
    }
    return null
  }

  protected initSeoItems(
    seoTitle: Title,
    seoMeta: Meta,
    title: string,
    description: string,
    keywords: string[],
    robots: string | null,
    type: string | null,
    image: string | null,
    permalink: string
  ) {

    seoTitle.setTitle(title)
    seoMeta.addTags([
      {
        name: 'keywords',
        content: keywords.join(',')
      },
      {name: 'description', description},
      {name: 'robots', content: robots == null ? 'index, follow' : robots},
      {property: 'og:type', content: type == null ? 'article' : type},
      {property: 'og:title', content: title},
      {property: 'og:description', content: description},
      {property: 'og:image', content: image == null ? '' : image},
      {property: 'og:url', content: permalink},
      {property: 'og:site_name', content: environment.app_name},
    ])
  }

  getPermalink(): string {
    return environment.app_url + this.router.url
  }


  private swipeCoord: [number, number] = [0, 0];
  private swipeTime: number = 0;
  SWIPE_START = 'swipe-action-start';
  SWIPE_END = 'swipe-action-end';
  SWIPE_LEFT = 'swipe-left';
  SWIPE_RIGHT = 'swipe-right';

  swipe(e: TouchEvent, when: string, eventKey: string): void {
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();

    if (when === this.SWIPE_START) {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === this.SWIPE_END) {
      const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;

      if (duration < 1000 //
        && Math.abs(direction[0]) > 30 // Long enough
        && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
        const swipe = direction[0] < 0 ? this.SWIPE_RIGHT : this.SWIPE_LEFT;
        // Do whatever you want with swipe
        this.eventBus.publish(eventKey, swipe);
      }
    }
  }

}
